/* eslint-disable */
import { FormValues } from "../../../components/Store/reducers/formReducer/types"

export const formatters = (data: FormValues) => {
    const resumesAttributes = data.userResumesAttributes[0]
    const isCurrentlyEmployed = data.situation === "tenure"

    let birthdayYear: number | null = null
    let birthdayMonth: number | null = null
    if (data.birthday) {
        const birthday = new Date(data.birthday)
        birthdayYear = birthday.getFullYear()
        birthdayMonth = birthday.getMonth() + 1
    }

    const occupationIds = Array.isArray(resumesAttributes.occupationIds)
        ? resumesAttributes.occupationIds
        : resumesAttributes.occupationIds
        ? [resumesAttributes.occupationIds]
        : []
    
    return {
        first_name: data.firstName,
        last_name: data.lastName,
        first_name_kana: data.firstNameKana,
        last_name_kana: data.lastNameKana,
        birthday_year: birthdayYear,
        birthday_month: birthdayMonth,
        sex: data.sex,
        tel: data.tel,
        line_id: data.lineId || null,
        line_contact_preferred: data.lineContactPreferred || null,
        situation: data.situation,
        prefecture_id: data.prefecture,
        city_id: data.city,
        city_address_id: data.cityAddressId,
        postal_code: data.postalCode,
        experience_years: (data.experienceYears && data.experienceYears !== '') ? data.experienceYears : null,
        email: data.email,
        password: data.password,
        user_resumes_attributes: {
            0: {
                company_name: resumesAttributes.companyName,
                brand_name: resumesAttributes.brandName || null,
                store_name: resumesAttributes.storeName || null,
                resume_auto: resumesAttributes.resumeAuto ?? false,
                employment_id: resumesAttributes.employmentId,
                genre_id: resumesAttributes.genreId,
                occupation_ids: occupationIds,
                job_description: resumesAttributes.detailedJobDetails,
                work_start_date_year: resumesAttributes.workStartYear,
                work_start_date_month: resumesAttributes.workStartMonth,
                work_end_date_year: isCurrentlyEmployed
                    ? null
                    : resumesAttributes.workEndDateYear,
                work_end_date_month: isCurrentlyEmployed
                    ? null
                    : resumesAttributes.workEndDateMonth,
            },
        },
        mail_magazine: data.mailMagazine ?? 1,
        agent_service: 1,
        resident_status: data.residentStatus || null,
    }
}
